import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiX, FiCalendar } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function EditLeaveModal({ show, onHide, data, onSave }) {
  const [leaveType, setLeaveType] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [session, setSession] = useState("");
  const [days, setDays] = useState("");
  const [reason, setReason] = useState("");

  const fromRef = useRef(null);
  const toRef = useRef(null);

  useEffect(() => {
    if (show && data) {
      setLeaveType(data.type || "");
      setSession(data.session || "");
      setDays(data.days ? data.days.replace(" Days", "") : "");
      setReason(data.reason || "");

      // Parse dates
      try {
        const fromParts = data.from.split(" ");
        const fromDateObj = new Date(
          `${fromParts[1]} ${fromParts[0]}, ${fromParts[2]}`,
        );
        setFromDate(fromDateObj);

        const toParts = data.to.split(" ");
        const toDateObj = new Date(
          `${toParts[1]} ${toParts[0]}, ${toParts[2]}`,
        );
        setToDate(toDateObj);
      } catch (error) {
        console.log("Error parsing dates");
      }
    }
  }, [show, data]);

  const handleSaveChanges = () => {
    if (!leaveType || !fromDate || !toDate || !session || !days) {
      alert("Please fill all required fields");
      return;
    }

    const updatedLeave = {
      ...data,
      type: leaveType,
      from: fromDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      to: toDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      session: session,
      days: `${days} Days`,
      reason: reason,
    };

    onSave(updatedLeave);
    onHide();
  };

  return (
    <>
      <style>{`

      .leave-modal .modal-dialog{
        max-width:750px;
      }

      .leave-modal .modal-content{
        border-radius:10px;
        border:none;
      }

      .leave-modal-header{
        padding:18px 22px;
        border-bottom:1px solid #eee;
        display:flex;
        justify-content:space-between;
        align-items:center;
      }

      .leave-modal-title{
        font-size:20px;
        font-weight:600;
      }

      .close-icon{
        cursor:pointer;
        font-size:22px;
        color:#6c757d;
      }

      .leave-modal-body{
        padding:22px;
      }

      .form-control,
      .form-select{
        height:44px;
        border-radius:6px;
      }

      .calendar-wrapper{
        position:relative;
      }

      .calendar-icon{
        position:absolute;
        right:140px;
        // top:12px;
        cursor:pointer;
        color:#6c757d;
      }

      .radio-group{
        display:flex;
        gap:20px;
        margin-top:10px;
      }

      .textarea-control{
        height:100px;
        resize:none;
      }

      .modal-footer-custom{
        border-top:1px solid #eee;
        padding:18px;
        display:flex;
        justify-content:flex-end;
        gap:10px;
      }

      .save-btn{
        background:#ff6a2f;
        border:none;
      }
        
@media (max-width:991px){

.calendar-icon{
right:12px;
}

.custom-input{
padding-right:42px;
}

}

@media (max-width:576px){


.calendar-icon{
right:60px;
}


.date-input{
padding-right:40px;
}
}

      `}</style>

      <Modal show={show} onHide={onHide} centered className="leave-modal">
        {/* HEADER */}
        <div className="leave-modal-header">
          <div className="leave-modal-title">Edit Leave</div>
          <FiX className="close-icon" onClick={onHide} />
        </div>

        {/* BODY */}
        <div className="leave-modal-body">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Leave Type</Form.Label>
              <Form.Select
                value={leaveType}
                onChange={(e) => setLeaveType(e.target.value)}
              >
                <option value="">Select</option>
                <option value="Medical Leave">Medical Leave</option>
                <option value="Casual Leave">Casual Leave</option>
                <option value="Annual Leave">Annual Leave</option>
              </Form.Select>
            </Form.Group>

            <Row className="mb-3">
              {/* FROM DATE */}
              <Col md={6}>
                <Form.Label>From</Form.Label>

                <div className="calendar-wrapper">
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    className="form-control"
                    placeholderText="dd/mm/yyyy"
                    ref={fromRef}
                    dateFormat="dd-MM-yyyy"
                  />

                  <FiCalendar
                    className="calendar-icon"
                    onClick={() => fromRef.current.setOpen(true)}
                  />
                </div>
              </Col>

              {/* TO DATE */}
              <Col md={6}>
                <Form.Label>To</Form.Label>

                <div className="calendar-wrapper">
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    className="form-control"
                    ref={toRef}
                    dateFormat="dd-MM-yyyy"
                  />

                  <FiCalendar
                    className="calendar-icon"
                    onClick={() => toRef.current.setOpen(true)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Select
                  value={session}
                  onChange={(e) => setSession(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="First Half">First Half</option>
                  <option value="Second Half">Second Half</option>
                  <option value="Full Day">Full Day</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Remaining Days</Form.Label>
                <Form.Control value="07" readOnly />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>No of Days</Form.Label>
                <Form.Control
                  type="text"
                  value={days}
                  onChange={(e) => setDays(e.target.value)}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Remaining Days</Form.Label>
                <Form.Control value="07" readOnly />
              </Col>
            </Row>

            <div className="radio-group">
              <Form.Check type="radio" label="Full Day" />
              <Form.Check type="radio" label="First Half" />
              <Form.Check type="radio" label="Second Half" />
            </div>

            <Form.Group className="mt-3">
              <Form.Label>Reason</Form.Label>
              <Form.Control
                as="textarea"
                className="textarea-control"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </Form.Group>
          </Form>
        </div>

        {/* FOOTER */}
        <div className="modal-footer-custom">
          <Button variant="light" onClick={onHide}>
            Cancel
          </Button>

          <Button className="save-btn" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </div>
      </Modal>
    </>
  );
}
